import api from "./api";

export const adminService = {
  getDashboard: () => api.get("/admin/dashboard"),

  // Users
  getUsers: (params?: object) => api.get("/admin/users", { params }),
  getUser: (id: number) => api.get(`/admin/users/${id}`),
  suspendUser: (id: number, message?: string) =>
    api.post(`/admin/users/${id}/suspend`, { message }),
  activateUser: (id: number) => api.post(`/admin/users/${id}/activate`),
  changeRole: (id: number, role: string) =>
    api.post(`/admin/users/${id}/role`, { role }),
  sendMessage: (id: number, message: string) =>
    api.post(`/admin/users/${id}/message`, { message }),
  clearMessage: (id: number) => api.delete(`/admin/users/${id}/message`),
  adjustBalance: (id: number, data: object) =>
    api.post(`/admin/users/${id}/adjust-balance`, data),
  resetDemo: (id: number) => api.post(`/admin/users/${id}/reset-demo`),
  deleteUser: (id: number) => api.delete(`/admin/users/${id}`),
  updateUser: (id: number, data: object) => api.put(`/admin/users/${id}`, data),

  // Transactions
  getTransactions: (params?: object) =>
    api.get("/admin/transactions", { params }),
  getPendingDeposits: () => api.get("/admin/transactions/pending-deposits"),
  getPendingWithdrawals: () =>
    api.get("/admin/transactions/pending-withdrawals"),
  approveDeposit: (id: number) =>
    api.post(`/admin/transactions/deposits/${id}/approve`),
  rejectDeposit: (id: number, note?: string) =>
    api.post(`/admin/transactions/deposits/${id}/reject`, { note }),
  approveWithdrawal: (id: number) =>
    api.post(`/admin/transactions/withdrawals/${id}/approve`),
  rejectWithdrawal: (id: number, note?: string) =>
    api.post(`/admin/transactions/withdrawals/${id}/reject`, { note }),

  // Trades
  getAdminTrades: (params?: object) => api.get("/admin/trades", { params }),
  getTradeStats: () => api.get("/admin/trades/statistics"),
  forceCloseTrade: (id: number) => api.post(`/admin/trades/${id}/force-close`),
  applyArbitrage: (id: number, profit_percent: number) =>
    api.post(`/admin/trades/${id}/apply-arbitrage`, { profit_percent }),
  updateTrade: (id: number, data: object) =>
    api.put(`/admin/trades/${id}`, data),
  deleteTrade: (id: number) => api.delete(`/admin/trades/${id}`),

  // KYC
  getKycList: (params?: object) => api.get("/admin/kyc", { params }),
  getKycDetail: (id: number) => api.get(`/admin/kyc/${id}`),
  approveKyc: (id: number) => api.post(`/admin/kyc/${id}/approve`),
  rejectKyc: (id: number, note: string) =>
    api.post(`/admin/kyc/${id}/reject`, { note }),

  // Settings
  getSettings: () => api.get("/admin/settings"),
  updateSettings: (settings: object) =>
    api.post("/admin/settings", { settings }),
  getDepositAddresses: () => api.get("/admin/settings/deposit-addresses"),
  setDepositAddress: (data: object) =>
    api.post("/admin/settings/deposit-addresses", data),
  deleteDepositAddress: (id: number) =>
    api.delete(`/admin/settings/deposit-addresses/${id}`),
  getCryptocurrencies: () => api.get("/admin/settings/cryptocurrencies"),
  updateCryptocurrency: (id: number, data: object) =>
    api.put(`/admin/settings/cryptocurrencies/${id}`, data),
};
